import {renderField, renderStringField} from "./utils";

export type FtsQuery = {
  query: string
  boost?: number
  analyzer?: string
};

export type MatchPhraseParams = FtsQuery & {
  slop?: number
};

export type MatchPhrasePrefixParams = MatchPhraseParams & {
  max_expansions?: number
};

export type MatchBoolPrefixParams = FtsQuery;

export type MultiMatchParams = FtsQuery & {
  type?: string
};

export const matchPhrase = (params: MatchPhraseParams): string => {
  return `
    {
      match_phrase: {
        name: {
          query: ${params.query}
          ${renderField('boost', params.boost)}
          ${renderStringField('analyzer', params.analyzer)}
          ${renderField('slop', params.slop)}
        }
      }
    }
  `;
};

export const matchPhrasePrefix = (params: MatchPhrasePrefixParams): string => {
  return `
    { 
      match_phrase_prefix: {
        name: { 
          query: ${params.query}
          ${renderField('boost', params.boost)}
          ${renderStringField('analyzer', params.analyzer)}
          ${renderField('slop', params.slop)}
          ${renderField('max_expansions', params.max_expansions)}
        }
      }
    }
  `;
};

export const matchBoolPrefix = (params: MatchBoolPrefixParams): string => {
  return `
    {
      match_bool_prefix: {
        name: { 
          query: ${params.query}
          ${renderField('boost', params.boost)}
          ${renderStringField('analyzer', params.analyzer)}
        }
      }
    }
  `;
};

export const multiMatch = (params: MultiMatchParams): string => {
  return `
    { 
      multi_match: { 
        query: ${params.query}
        ${renderField('boost', params.boost)}
        ${renderStringField('analyzer', params.analyzer)}
        ${renderField('type', params.type)}
      }
    }
  `;
};

